import React from "react";
import "./Header.module.css";

const Header = () => {
  return (
    <header>
      <h1>Add members to Front-end development team</h1>
    </header>
  );
};

export default Header;
